import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyMemberRoles = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-member-roles", jiraSpaEntry: "async-jira-eoc-member-roles" */ '@atlassian/jira-eoc-member-roles/src/ui/index.tsx'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyMemberRoles} pageId="async-jira-eoc-member-roles" shouldShowSpinner={false} />
);
